"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@headlessui/react");
const react_2 = __importDefault(require("react"));
function LabelComponent({ ...props }, ref) {
    return (0, jsx_runtime_1.jsx)(react_1.Label, { ...props, ref: ref });
}
const Label = react_2.default.forwardRef(LabelComponent);
exports.Label = Label;
